import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject, Subscriber } from "rxjs";
import { AvailabilityService } from "./Availability.service";
import { LocationsService } from "./Locations.service";
import { CategoryFiltersDTO } from "../../../../shared/models/CategoryFilters/CategoryFilters";
import { LocationCategoryDTO } from "../models/LocationCategoryDTO";
import { SelectedFilter } from "../models/Filters";
@Injectable({
  providedIn: "root",
})
export class PanelLocationsService {
  public Result;
  
  private isLoading$: Subject<boolean> = new Subject();
  private searchData$: Subject<string> = new Subject();
  private searchVisibility$: Subject<boolean> = new Subject();
  isVisiblePanel$: Subject<boolean> = new Subject<boolean>();

  public isVisible: boolean = false;
  public availabilityFilter : boolean = false;

  public tabCategoryFiltersSelected: BehaviorSubject< {filters: { id: string, filtersSelected: SelectedFilter[] }[], categoryToBeAffected: LocationCategoryDTO} > = new BehaviorSubject({filters: [], categoryToBeAffected: null});
  public canClosePanel: BehaviorSubject<boolean> = new BehaviorSubject(true);

  private locationDataChanged$: Subject<void> = new Subject<void>();


  constructor(private locationService: LocationsService, private availabilityService: AvailabilityService) {
  }

  setLoading(resp) {
    this.isLoading$.next(resp);
  }

  getLoading() {
    return this.isLoading$.asObservable();
  }

  setSearchData(resp) {
    this.searchData$.next(resp);
  }

  getSearchData() {
    return this.searchData$.asObservable();
  }

  setSearchVisibility(resp) {
    this.searchVisibility$.next(resp);
  }

  getSearchVisibility() {
    return this.searchVisibility$.asObservable();
  }


  findByIdentifier(identifier): any {
    return this.locationService.findByIdentifier(identifier);
  }

  findUpdatedByIdentifier(identifier, tipo): any {
    return this.locationService.findUpdatedByIdentifier(identifier, tipo);
  }
  FindAllByIdentifier(identifier): any {
    return this.locationService.FindAllByIdentifier(identifier);
  }


  GetCountListActualizados(filters: any[]): any {
    return this.locationService.GetCountListActualizados(filters);
  }

  GetCountListDesactualizados(filters: any[]): any {
    return this.locationService.GetCountListDesactualizados(filters);
  }

  GetCountListSinReporte(filters: any[]): any {
    return this.locationService.GetCountListSinReporte(filters);
  }

  GetCountByIdLocationCategory(idLocationCategory:number, filters: any[]) {
    return this.locationService.GetCountByIdLocationCategory(idLocationCategory,filters);
  }

  GetListDesactualizados(): any {
    return this.locationService.GetListDesactualizados();
  
  }

  //deprecado
  GetListByIdLocationCategory(idLocationCategory: number): any {
    return this.locationService.GetListByIdLocationCategory(idLocationCategory);
  }

  //traen listas paginadas de 20 registros

  GetListActualizadosPage(page:number): any {
    return this.locationService.GetListActualizadosPage(page);
  }

  GetListDesactualizadosPage(page:number): any {
    return this.locationService.GetListDesactualizadosPage(page);
  
  }
  GetListSinReportePage(page:number): any {
    return this.locationService.GetListSinReportePage(page);
  }

  GetListByIdLocationCategoryPage(idLocationCategory: number, page:number, filters: CategoryFiltersDTO[]): any {
    return this.locationService.GetListByIdLocationCategoryPage(idLocationCategory, page, filters);
  }

  GetListNamesFilterByIdLocationCategoryPage(idLocationCategory: number, page:number): any {
    return this.locationService.GetListNamesFilterByIdLocationCategoryPage(idLocationCategory, page);
  }

  GetLocationsByPageFilter(zoneId: string, idLocationCategory: number, page:number){
    return this.locationService.GetLocationsByPageFilter(zoneId, idLocationCategory, page);
  }

  getListFilter(filtersRequest : any[]): any {
     return this.locationService.getListFilter(filtersRequest);
  }

  getListFilterTab(filtersRequest : any[], tipoTab: string, finder: string, idLocationCategory: number): any {
     return this.locationService.getListFilterTab(filtersRequest, tipoTab, finder, idLocationCategory);
  }

  GetListAvailabilityFilterByLocationCategory(filtersRequest : any[], initialDate: string, finalDate: string, idLocationCategories: number[]): any {
     return this.availabilityService.GetListAvailabilityFilterByLocationCategory(filtersRequest, initialDate, finalDate, idLocationCategories);
  }

  
  notifyLocationDataChanged() {
    this.locationDataChanged$.next();
  }

  getLocationDataChanged(): Observable<void> {
    return this.locationDataChanged$.asObservable();
  }

  getVisibilityPanel(): Observable<boolean> {
    return this.isVisiblePanel$.asObservable();
  }
  setVisibilityPanel(op) {
    this.isVisible = op;
    this.isVisiblePanel$.next(op);
  }


}
